import type { Environment } from './environment.type';

export const environment: Environment = {
  production: true,
  name: 'docker',
  auth0: {
    domain: '%%AUTH0_DOMAIN%%',
    clientId: '%%AUTH0_CLIENT_ID%%',
    authorizationParams: {
      // eslint-disable-next-line camelcase
      redirect_uri: window.location.origin,
      audience: '%%AUTH0_AUDIENCE%%',
    },
  },
  api: {
    serverUrl: '%%API_SERVER_URL%%',
  },
  launchDarkly: {
    clientSideId: '%%LAUNCHDARKLY_CLIENT_SIDE_ID%%',
  },
};
